import { trans } from '@/_providers/Translation'
import React, { useRef } from 'react'

function Filter(props) {
    const searchInputRef = useRef(null)

    const handleClearFilters = () => {
        props.handleSearch('name', '')
        searchInputRef.current.value = ''
    }

    return (
        <form className="filter-standard">

            <div className="col">
                <input
                    type="search"
                    name="name"
                    onKeyUp={(e) => props.handleSearch(e.target.name, e.target.value)}
                    onChange={(e) => props.handleSearch(e.target.name, e.target.value)}
                    placeholder='Име'
                    ref={searchInputRef}
                    value={props.filters.name}
                />
            </div>
            <div className='col'>
                <button type='button' className='button-clear-filter' onClick={handleClearFilters}>
                    {trans('buttons.clearFilter')}
                </button>
            </div>

        </form>
    )
}

export default Filter